import Vue from 'vue';
import VueMoment from 'vue-moment';
import VueCookies from 'vue-cookies';
import VueClipboard from 'vue-clipboard2';
import VueGtag from 'vue-gtag';
import store from './store';
import router from './router';
import vuetify from './plugins/vuetify';
import { initRequestInterceptors } from './axios';
import App from './App';
import connect from './helpers/WebSocket';
import './plugins/toast-notifications';
import '@/globalComponents';

Vue.config.devtools = true;
// Vue.config.productionTip = false;

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(VueCookies);
Vue.use(VueMoment);
Vue.use(VueGtag, {
  config: { id: 'UA-159336653-4' },
});

initRequestInterceptors({ store });
connect();

new Vue({
  router,
  store,
  vuetify,
  components: { App },
  template: '<App />',
}).$mount('#app');
